import { SelectOption } from "@assets/types";

/** Max input size for CreateSeaFreight booking specific fields - values that have the maximum characters in Doris and Sw.v1 */
export const MAX_INPUT_TEMPLATE_NAME = 150;
export const MAX_INPUT_LENGTH_EMAIL = 100;
export const MAX_INPUT_LENGTH_GENERIC = 35;
export const MAX_INPUT_LENGTH_CARGO_DESC = 30;
export const MAX_INPUT_LENGTH_PHONE = 25;
export const MAX_INPUT_LENGTH_POSTAL_CODE = 10;

export const enum TRANSFER_ADDRESS_TYPE {
  FROM = "From",
  TO = "To",
}

export enum PARTNER_FILL_OUT_TYPE {
  PREVIOUS = "PREVIOUS",
  NEW = "NEW",
  BOOKINGPARTY = "BOOKINGPARTY",
}

export enum PARTNER_ADDRESS_TYPE {
  CONSIGNEE = "Consignee",
  SHIPPER = "Shipper",
  NOTIFIER = "Notifier",
}

export const BILLS: SelectOption<string>[] = [
  {
    value: "W",
    label: "LABEL_SEAWAYBILL",
  },
  {
    value: "G",
    label: "LABEL_BILLOFLADING",
  },
];

export const SORT_BY_VALUES = [
  {
    label: "LABEL_SORT_TEMPLATE_NAME_ASC",
    value: "name ASC",
  },
  {
    label: "LABEL_SORT_TEMPLATE_NAME_DESC",
    value: "name DESC",
  },
  {
    label: "LABEL_SORT_TEMPLATE_NUMBER_ASC",
    value: "number ASC",
  },
  {
    label: "LABEL_SORT_TEMPLATE_NUMBER_DESC",
    value: "number DESC",
  },
  {
    label: "LABEL_SORT_LAST_USED_ASC",
    value: "lastused ASC",
  },
  {
    label: "LABEL_SORT_LAST_USED_DESC",
    value: "lastused DESC",
  },
];
